import * as fromCertificates from '~/store/reducers/certificates';

export const getCertificatesIsFetched = (state) => fromCertificates.getIsFetched(state);
export const getCertificateById = (state, id) => fromCertificates.getCertificateById(state, id);
export const getCertificateIds = (state) => fromCertificates.getCertificateIds(state);
export const getCertificates = (state) => fromCertificates.getCertificates(state);
